import types from './types';

const setPlayedClass = (data) => ({
  type: types.SET_PLAYED_CLASS,
  data,
});

const nextPhase = (data) => ({
  type: types.NEXT_PHASE,
  data,
});

const setPhaseGoalState = (data) => ({
  type: types.SET_PHASE_GOAL_STATE,
  data,
});

const startGame = (data) => ({
  type: types.START_GAME,
  data,
});

const restartGame = (data) => ({
  type: types.RESTART_GAME,
  data,
});

const restoreGame = (data) => ({
  type: types.RESTORE_GAME,
  data,
});

const resetGame = (data) => ({
  type: types.RESET_GAME,
  data,
});

const setControlledPlayer = (data) => ({
  type: types.SET_CONTROLLED_PLAYER,
  data,
});

const setDisplayName = (data) => ({
  type: types.SET_DISPLAY_NAME,
  data,
});

const changeRule = (data) => ({
  type: types.CHANGE_RULE,
  data,
});

const setPhaseLoading = (data) => ({
  type: types.SET_PHASE_LOADING,
  data,
});

const setGameMode = (data) => ({
  type: types.SET_GAME_MODE,
  data,
});

const setUnlockedDifficulties = (data) => ({
  type: types.SET_UNLOCKED_DIFFICULTIES,
  data,
});

export default {
  setPlayedClass,
  nextPhase,
  setPhaseGoalState,
  startGame,
  restartGame,
  restoreGame,
  resetGame,
  setControlledPlayer,
  setDisplayName,
  changeRule,
  setPhaseLoading,
  setGameMode,
  setUnlockedDifficulties,
};
